import { createApiRef } from '@backstage/core-plugin-api';

export interface PlatformEntity {
  kind: string;
  name: string;
  title: string;
  description: string;
  status: string;
  domain: string[];
  owner: string;
  metadata: Record<string, unknown>;
  spec: Record<string, unknown>;
}

export interface GenerateEntityRequest {
  entityType: 'Skill' | 'Capability' | 'Persona';
  prompt: string;
  domain?: string[];
}

export interface GenerateEntityResponse {
  content: string;
  warnings: string[];
  similarEntities: Array<{ name: string; score: number }>;
}

export interface PlatformStudioApi {
  listEntities(kind: string): Promise<PlatformEntity[]>;
  getEntity(kind: string, name: string): Promise<PlatformEntity>;
  generateEntity(request: GenerateEntityRequest): Promise<GenerateEntityResponse>;
  checkSimilarity(kind: string, description: string): Promise<Array<{ name: string; score: number }>>;
}

export const platformStudioApiRef = createApiRef<PlatformStudioApi>({
  id: 'plugin.platform-studio.api',
});
